export class FlavorConstants { public static readonly TEST = false; }
